import React, { useEffect, useContext } from 'react';
import PersonalLoanFinderContent from '@/components/PersonalLoanPageContent/PersonalLoanFinderContent';
import { AnalyticsContext } from 'latitude-analytics';

const PersonalLoanFinderPage = props => {
  const [analytics] = useContext(AnalyticsContext);
  useEffect(() => {
    const sourceCode = localStorage.getItem('source_code') || 'IDAAA';
    // adding pageData to analytics
    analytics.pageData = {
      page_pageTitle: 'personal-loan',
      page_pageType: 'product-details-page',
      page_siteSection: 'loans',
      page_siteSubsection: 'affiliate-finder',
      product_productid: ['PLAULF-WEB'],
      application_sourcecode: sourceCode || 'IDAAA'
    };
  }, []);
  return (
    <PersonalLoanFinderContent
      {...props}
      title="Personal Loan - Finder"
      description="Save $395 on a Personal Loan"
    />
  );
};

export default PersonalLoanFinderPage;
